{% block sw_cms_element_acris_blog_product_slider_preview %}
    <div class="sw-cms-el-preview-acris-blog-product-slider">
        <mt-icon
                name="regular-chevron-left"
                size="10"
        />
        <sw-cms-product-box-preview />
        <mt-icon
                name="regular-chevron-right"
                size="10"
        />
    </div>
{% endblock %}